import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { ThanhTra, Reception } from 'api';
import { RowItemDanhSachCuocThanhTra } from 'modules/thanh-tra/datatable';
import ThemMoiDoiTuongThanhTra from './ThemMoiDoiTuongThanhTra.jsx';
import { get, isEmpty } from 'lodash';
import { API_URL } from 'constants/config';
import { Button } from '@blueprintjs/core';
import { exportExcel } from "constants/exportExcel";
import { Dialog } from "@blueprintjs/core";
import { Link } from 'react-router';
import { Toastr } from 'modules/toastr';
class DanhSachCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      news: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      linhVucThanhTraList: [],
      chucNangCuocThanhTra: '',
      tenDonViChuTri: '',
      cuocThanhTraNhieuDoiTuong: '',
      donViChuTriList: [],
      allowDelete: true,
      donViChuTriDefault: {
        coQuanQuanLyId: '',
        ten: ''
      },
      noiDungThanhTra: '',
      showDialogDuLieuLoi: false,
      messageDuLieuLoi: '',
      paramsRequestListError: '',
    }
  }

  componentDidMount() {
    this.getDonViChuTri();
  }

  componentWillReceiveProps(nextProps) {
    let data = get(nextProps, 'data.cuocThanhTras');
    if (!isEmpty(nextProps.dataCuocThanhTra)) {
      data = get(nextProps, 'dataCuocThanhTra');
    }
    if (this.props.data != nextProps.data) {
      this.state.data = [];
      data.map(item => {
        item.allowEdit = true;
        item.allowDelete = true;
        if (get(item, 'tienDoThanhTraInfo.type') === "LUU_HO_SO") {
          item.allowDelete = false;
          item.allowEdit = false;
        }
        this.state.data.push(item);
      });
      this.setState({ ...this.state });
    }

    if (this.props.oldData != nextProps.oldData && !this.state.data.length) {
      nextProps.oldData.cuocThanhTras.map(item => {
        item.allowEdit = true;
        item.allowDelete = true;
        if (get(item, 'tienDoThanhTraInfo.type') === "LUU_HO_SO") {
          item.allowDelete = false;
          item.allowEdit = false;
        }
        this.state.data.push(item);
      });
      this.setState({ ...this.state });
    }

  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (!this.refs.dsctt) return;
      if (res.data) {
        this.state.linhVucThanhTraList = res.data;
      } else {
        this.state.linhVucThanhTraList = [];
      }
      this.setState({ ...this.state });
    });
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (!this.refs.dsctt) return;
      let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      if (res.data && res.data._embedded) {
        this.state.donViChuTriList = res.data._embedded.coQuanQuanLies;
        res.data._embedded.coQuanQuanLies.map(item => {
          if (item.coQuanQuanLyId == userInfo.donViId) {
            this.state.donViChuTriDefault = {
              coQuanQuanLyId: item.coQuanQuanLyId,
              ten: item.ten
            }
          }
        });
      } else {
        this.state.donViChuTriList = [];
      }
      this.setState({ ...this.state });
    });
  }

  handleRemove(item, index) {
    if (item.id) {
      this.props.onRemove(item.id);
    }
    this.state.data.splice(index, 1);
    this.setState({ ...this.state });
    this.props.onChange(this.state.data);
  }

  saveThanhTra(data) {
    this.state.donViChuTriDefault = {
      coQuanQuanLyId: data.donViChuTriId,
      ten: data.tenDonViChuTriInfo
    }

    let newItem = {
      ...data,
      cuocThanhTraNhieuDoiTuong: data.cuocThanhTraNhieuDoiTuong,
      donViChuTriInfo: this.state.donViChuTriDefault,
      tenDonViChuTri: this.state.tenDonViChuTri
    }
    this.state.data.push(newItem);
    this.props.dispatch({
      type: 'LOAD_DATA',
      data: this.state.data
    });
    this.setState({ ...this.state });
    this.props.onChange(this.state.data);
  }

  handleExportData(data) {
    let idList = [];
    this.state.data.map(item => {
      idList.push(item.doiTuongThanhTraId);
    });
    data.map(item => {
      if (idList.indexOf(item.doiTuongThanhTraId) == -1) {
        let newItem = {
          doiTuongThanhTraInfo: item,
          donViChuTriInfo: this.state.donViChuTriDefault,
          donViPhoiHop: '',
          kyThanhTra: '',
          linhVucThanhTraInfo: {
            text: '',
            type: ''
          },
          thoiHanThanhTra: ''
        }
        this.state.data.push(newItem);
      }
    });
    this.setState({ ...this.state });
    this.props.onChange(this.state.data);
  }

  onSave(data, index) {
    this.state.data[index] = data
    this.setState({ ...this.state });
    this.props.onChange(this.state.data);
  }

  checkIsKiemTra() {
    const result = window.location.pathname.includes('kiem-tra') || get(this.props, 'isKiemTra');
    return result;
  }

  handleExportExampleKiemTra() {
    const URL = String(API_URL) + "/cuoc-thanh-kiem-tra/download-import-template"
    exportExcel(URL, 'import-template-kiem-tra.xlsx');
  }

  handleImportExampleKiemTra(res, params) {
    let result = [];
    let countDuLieuLoi = 0;
    if (!isEmpty(res.data.dsCuocThanhTra)) {
      result = [...this.state.data, ...get(res.data, 'dsCuocThanhTra')];
    } else {
      result = [...this.state.data]
    }

    if (!isEmpty(res.data.duLieuLoi)) {
      countDuLieuLoi = get(res.data, 'duLieuLoi').length;
      this.setState({
        ...this.state,
        paramsRequestListError: params
      })
    }
    this.setState({
      ...this.state,
      data: result,
    });
    this.props.onChange(result);
    if (countDuLieuLoi > 0) {
      this.setState({
        ...this.state,
        messageDuLieuLoi: `Danh sách đối tượng thanh tra vừa tải lên có ${countDuLieuLoi} đối tượng không có trong danh sách đối tượng thanh tra. Vui lòng bấm tải xuống danh sách lỗi để kiểm tra lại`
      }, () => {
        this.toggleDialogDuLieuLoi()
      });
    }
  }

  handleDownloadDuLieuLoi(dataError) {
    const a = document.createElement("a");
    const url = window.URL.createObjectURL(dataError);
    a.href = url;
    a.download = 'filedulieuloi.xlsx';
    a.click();
  }

  handleDownloadListErrorFile() {
    Reception.actions.postImportCuocKiemTra.request('', this.state.paramsRequestListError).then(res => {
      if (res.data) {
        this.handleDownloadDuLieuLoi(res.data);
      }
    }).catch(error => {
      Toastr(get(error, 'response.data.errors[0].detail'), 'error');
    });
  }

  toggleDialogDuLieuLoi() {
    this.setState({
      ...this.state,
      showDialogDuLieuLoi: !this.state.showDialogDuLieuLoi
    })
  }

  render() {
    let checkKeHoach = this.props.keHoach && this.props.keHoach.keHoachDaCoQuyetDinh;
    return (
      <section className='wrap-block' ref="dsctt">
        <div className='row pl10 pr10 heading-addnew-dttt'>
          <h2 className='title-13 col-100 pt10 pl20 pr20 pb15'>{`1.1 Danh mục cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
          <ThemMoiDoiTuongThanhTra isKiemTra={this.checkIsKiemTra()} keHoach={checkKeHoach} namKeHoachThanhTra={this.props.namKeHoachThanhTra ? this.props.namKeHoachThanhTra : this.props.oldData.namThanhTra} saveThanhTra={this.saveThanhTra.bind(this)} exportData={this.handleExportData.bind(this)} importData={this.state.data} />
        </div>
        <div className='row pl10 pr10 '>
          <DataTable
            header={this.props.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? header.thanhTra.DKKHTT2 : header.thanhTra.DKKHTT}
            plusColum={1}
            dataList={this.state.data}
            hideButtonExport={true}
            hidePagination={true}
            pageData={this.state.pageData} parent={this}
            tableLoading={this.state.tableLoading}
            isKiemTra={this.checkIsKiemTra()}
            handleExportExampleKiemTra={this.handleExportExampleKiemTra.bind(this)}
            handleImportEmxampleKiemTra={this.handleImportExampleKiemTra.bind(this)}
          >
            <RowItemDanhSachCuocThanhTra keHoach={checkKeHoach} onSave={this.onSave.bind(this)} isSubmit={this.props.isSubmit} tenDonViChuTri={this.state.tenDonViChuTri} namKeHoachThanhTra={this.props.namKeHoachThanhTra} />
          </DataTable>
          {
            !isEmpty(this.state.data) &&
            <div className='pl20 pr20 pb10'>
              <Button className='btn-green tt-export' text='Xuất Excel' onClick={this.props.handleExport} />
            </div>
          }
          {
            <Dialog
              isOpen={this.state.showDialogDuLieuLoi}
              onClose={this.toggleDialogDuLieuLoi.bind(this)}
              title="Thông báo"
              className="panel-popup category medium"
              style={{ width: 350 }}
            >
              <div className="pt-dialog-body">
                {this.state.messageDuLieuLoi}
              </div>
              <div className="pt-dialog-footer">
                <Link onClick={this.toggleDialogDuLieuLoi.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={"btn-action btn-save"} onClick={this.handleDownloadListErrorFile.bind(this)}>
                  <span>Tải xuống danh sách lỗi</span>
                </Link>
              </div>
            </Dialog>
          }
        </div>
      </section>
    );
  }
}

DanhSachCuocThanhTra.defaultProps = {
  data: {},
  oldData: {},
  dataCuocThanhTra: []
}

function bindStateToProps(state) {
  return {
    dataCuocThanhTra: state.dataCuocThanhTra.data,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  };
}
export default connect(bindStateToProps)(DanhSachCuocThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/DanhSachCuocThanhTra.jsx